// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-search-field',
    // #endregion
    // #region Mixins
    mixins: [appHost.mixins.form],
    // #endregion
    // #region Props
    props: {
        dataStore: {
            type: Object,
            default: null
        },
        dataAdapter: {
            type: Object,
            default: null
        },
        dataArgs: {
            type: Object,
            default: null
        },
        dataLoadMode: {
            type: String,
            default: 'client',
        },
        idField: {
            type: String,
            default: null,
        },
        keyField: {
            type: String,
            default: null,
        },
        parentField: {
            type: String,
            default: null,
        },
        labelField: {
            type: String,
            default: null,
        },
        iconField: {
            type: String,
            default: null,
        },
        columns: {
            type: Array,
            default: () => [],
        },
        pageSize: {
            type: Number,
            default: 20,
        },
        dropdownMode: {
            type: String,
            default: 'table',
        },
        dropDownHeight: {
            type: Number,
            default: 280,
        },
        selectLeafOnly: {
            type: Boolean,
            default: false,
        },
    },
    // #endregion
});
// #endregion
